import {
  GET_REGISTRATION_LIST, GET__REGISTRATION_DETAILS,
} from "../types";
import strings from "translate/language";
import { errorToast, unAuthorizedError } from "utils/httpClient";
import registrationService from "../service/registrationService";

export const getRegistrationList = (item) => async (dispatch) => {
  try {
    const res = await registrationService.getRegistrationList(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_REGISTRATION_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_REGISTRATION_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getRegistrationDetails = (item) => async (dispatch) => {
  try {
    const res = await registrationService.getRegistrationDetails(item);

    if (res.data.status === 200) {
      dispatch({
        type: GET__REGISTRATION_DETAILS,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
